import { APP_PERMISSIONS } from '@exam-management/permissions';
import { Button, type ButtonProps } from '@shared/components';
import { WithPermission } from '@shared/permissions';

import { QSetListModalAction, useQSetListModal } from '../../providers';

type GenerateQSetButtonProps = ButtonProps;

export default function GenerateQSetButton(props: GenerateQSetButtonProps) {
  const { setAction } = useQSetListModal();

  const handleClick = () => {
    setAction(QSetListModalAction.GENERATE_QSET);
  };

  return (
    <WithPermission
      requiredPermission={[APP_PERMISSIONS.EXAM.QSET.CREATE, APP_PERMISSIONS.EXAM.QCONFIG.VIEW]}
    >
      <Button onClick={handleClick} {...props} />
    </WithPermission>
  );
}
